var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-plan-widget"},[_c('Actions',{attrs:{"as-widget":"","plan-ids-from-widget":_vm.numberPlanIds.join(),"landscape":_vm.landscape}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }